// @ts-nocheck

function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initListeningHeartbeat() {
    if (typeof window !== 'undefined' && window.__RP_HEARTBEAT_BOOTED) return;
    if (typeof window !== 'undefined') window.__RP_HEARTBEAT_BOOTED = true;

/**
 * Listening heartbeat — envia telemetria a cada 5 min com player ativo.
 * Pausa se idle > 30s. Nova sessão ao trocar de rádio ou recarregar a página.
 */
(function () {
    'use strict';

    var INTERVAL_MS = 5 * 60 * 1000;
    var IDLE_MS = 30 * 1000;
    var CHECK_MS = 5000;
    var EVENT_NAME = 'radio_listening_heartbeat';
    var MAX_BACKOFF_MS = 5 * 60 * 1000;

    var state = {
        sessionId: null,
        radioId: null,
        radioName: null,
        listeningMinutes: 0,
        heartbeatTimer: null,
        checkTimer: null,
        lastActiveAt: 0,
        backoffMs: 5000,
        armed: false
    };

    function heartbeatUrl() {
        var base = (typeof window !== 'undefined' && window.APPRADIO_PUBLIC_BASE != null)
            ? String(window.APPRADIO_PUBLIC_BASE).replace(/\/$/, '')
            : '';
        return base + '/ajax/ajax-listening-heartbeat.php';
    }

    function newSessionId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return window.crypto.randomUUID();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }

    function getGlobalPlayerMeta() {
        var player = document.getElementById('radio-global-player');
        if (!player) {
            return null;
        }
        var id = parseInt(player.getAttribute('data-radio-id') || '0', 10);
        var name = (player.getAttribute('data-radio-title') || '').trim();
        if (!id || !name) {
            return null;
        }
        return { radioId: id, radioName: name };
    }

    function getPlaybackState() {
        var mgr = window.musicPlayerManager;
        if (mgr && mgr.audio && mgr.currentRadio) {
            var homePlaying = mgr.isPlaying && !mgr.audio.paused && !mgr.audio.ended;
            if (homePlaying) {
                return {
                    active: true,
                    radioId: parseInt(mgr.currentRadio.id, 10) || 0,
                    radioName: (mgr.currentRadio.name || mgr.currentRadio.title || '').trim()
                };
            }
        }

        var audio = document.getElementById('radio-detail-audio');
        if (audio && !audio.paused && !audio.ended) {
            var meta = getGlobalPlayerMeta();
            if (window.__RADIOPRO_PAGE__ && window.__RADIOPRO_PAGE__.id) {
                meta = {
                    radioId: parseInt(window.__RADIOPRO_PAGE__.id, 10) || 0,
                    radioName: (window.__RADIOPRO_PAGE__.title || '').trim()
                };
            }
            if (meta && meta.radioId && meta.radioName) {
                return {
                    active: true,
                    radioId: meta.radioId,
                    radioName: meta.radioName
                };
            }
        }

        return { active: false, radioId: 0, radioName: '' };
    }

    function clearHeartbeatTimer() {
        if (state.heartbeatTimer) {
            clearTimeout(state.heartbeatTimer);
            state.heartbeatTimer = null;
        }
    }

    function clearCheckTimer() {
        if (state.checkTimer) {
            clearInterval(state.checkTimer);
            state.checkTimer = null;
        }
    }

    function resetSession(radioId, radioName) {
        state.sessionId = newSessionId();
        state.radioId = radioId;
        state.radioName = radioName;
        state.listeningMinutes = 0;
        state.lastActiveAt = Date.now();
        state.armed = true;
        clearHeartbeatTimer();
        state.heartbeatTimer = setTimeout(onHeartbeatDue, INTERVAL_MS);
    }

    function stopTracking() {
        state.armed = false;
        clearHeartbeatTimer();
    }

    function onHeartbeatDue() {
        state.heartbeatTimer = null;
        var playback = getPlaybackState();
        if (!playback.active || !state.armed) {
            stopTracking();
            return;
        }

        if (playback.radioId !== state.radioId) {
            resetSession(playback.radioId, playback.radioName);
            return;
        }

        state.listeningMinutes += 5;
        sendHeartbeat().finally(function () {
            if (!state.armed) {
                return;
            }
            var stillPlaying = getPlaybackState();
            if (!stillPlaying.active) {
                stopTracking();
                return;
            }
            state.heartbeatTimer = setTimeout(onHeartbeatDue, INTERVAL_MS);
        });
    }

    function sendHeartbeat(retryCount) {
        if (!state.sessionId || !state.radioId || !state.radioName) {
            return Promise.resolve();
        }

        var attempts = typeof retryCount === 'number' ? retryCount : 0;

        var payload = {
            event: EVENT_NAME,
            session_id: state.sessionId,
            radio_id: state.radioId,
            radio_name: state.radioName,
            listening_minutes: state.listeningMinutes
        };

        return fetch(heartbeatUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            keepalive: true,
            body: JSON.stringify(payload)
        }).then(function (res) {
            if (res.status === 204) {
                state.backoffMs = 5000;
                return;
            }
            throw new Error('heartbeat_failed_' + res.status);
        }).catch(function () {
            if (attempts >= 3) {
                return;
            }
            state.backoffMs = Math.min(state.backoffMs * 2, MAX_BACKOFF_MS);
            return new Promise(function (resolve) {
                setTimeout(resolve, state.backoffMs);
            }).then(function () {
                return sendHeartbeat(attempts + 1);
            });
        });
    }

    function ensureTracking() {
        var playback = getPlaybackState();
        if (!playback.active || !playback.radioId || !playback.radioName) {
            if (Date.now() - state.lastActiveAt > IDLE_MS) {
                stopTracking();
            }
            return;
        }

        state.lastActiveAt = Date.now();

        if (!state.armed || playback.radioId !== state.radioId) {
            resetSession(playback.radioId, playback.radioName);
        }
    }

    function bindAudioElement(audio) {
        if (!audio || audio.__listeningHeartbeatBound) {
            return;
        }
        audio.__listeningHeartbeatBound = true;
        audio.addEventListener('play', ensureTracking);
        audio.addEventListener('pause', function () {
            var playback = getPlaybackState();
            if (!playback.active) {
                state.lastActiveAt = Date.now();
            }
        });
        audio.addEventListener('ended', function () {
            state.lastActiveAt = Date.now();
        });
    }

    function init() {
        document.addEventListener('radio-play', function (e) {
            var detail = (e && e.detail) || {};
            var radioId = parseInt(detail.radioId, 10) || 0;
            var radioName = (detail.radioName || '').trim();
            if (radioId && radioName) {
                resetSession(radioId, radioName);
            }
        });

        document.addEventListener('radio-stop', function () {
            state.lastActiveAt = Date.now();
        });

        bindAudioElement(document.getElementById('radio-detail-audio'));

        if (window.musicPlayerManager && window.musicPlayerManager.audio) {
            bindAudioElement(window.musicPlayerManager.audio);
        } else {
            rpOnReady( function () {
                if (window.musicPlayerManager && window.musicPlayerManager.audio) {
                    bindAudioElement(window.musicPlayerManager.audio);
                }
            });
        }

        state.checkTimer = setInterval(ensureTracking, CHECK_MS);
        ensureTracking();
    }

    if (document.readyState === 'loading') {
        rpOnReady( init);
    } else {
        init();
    }
})();

}
